module.exports = __webpack_public_path__ + "img/Komite-Audit-Ahmad-Subagyo.a1651a0a.jpg";